var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('form',{attrs:{"action":"/msgraph/authorize","method":"post"}},[_c('button',{attrs:{"type":"submit"}},[_vm._v("Authorize")])])])}
var staticRenderFns = []

export { render, staticRenderFns }